import auth from '~/auth';

function getVendorPortalBaseUrl() {
  return window.configs.VENDOR_PORTAL.endsWith('/') ? window.configs.VENDOR_PORTAL : `${window.configs.VENDOR_PORTAL}/`;
}

export async function getVendorPortalUrl(path: string) {
  const token = await auth.getAccessToken();

  if (!token) {
    throw new Error('You are not logged in.');
  }

  const url = new URL(path.replace(/^\/+/, ''), getVendorPortalBaseUrl());
  url.searchParams.set('token', token);

  return url.toString();
}
